import request from '@/utils/request';

export function getTalentList(query) {
  return request({
    url: '/talents',
    method: 'get',
    params: query,
  });
}

export function createTalent(query) {
  return request({
    url: '/talents',
    method: 'post',
    data: query,
  });
}

export function updateTalent(query) {
  return request({
    url: `/talents/${query.id}`,
    method: 'patch',
    data: query,
  });
}

export function deleteTalent(query) {
  return request({
    url: `/talents/${query.id}`,
    method: 'delete',
  });
}

export function getTalent(id) {
  return request({
    url: `/talents/${id}`,
    method: 'get',
  });
}

export function talentCount() {
  return request({
    url: '/talents/count',
    method: 'get',
  });
}
